const ExternalLinks = {
  legacyPublish: "https://www.wowza.com/developer/webrtc/dev-view-publish",
  legacyPlay: "https://www.wowza.com/developer/webrtc/dev-view-play",
  legacyLinkText: "Still using Wowza Streaming Engine 4.10.0 or earlier?",
  legacyLinkLabel: "Go here"
}

export default ExternalLinks;
